import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import AceEditor from 'react-ace';
import HotTable from 'react-handsontable';
import {  getEnvelopeDetails,
          sendToPostOffice } from './helpers/fireHelper';
import { withRouter } from 'react-router-dom';

import Options from './Options';
import Settings from './Settings';
import Iframe from './Iframe';

import * as firebase from 'firebase'

import 'brace/mode/javascript';
import 'brace/mode/html';
import 'brace/mode/css';
import 'brace/theme/monokai';

class Envelope extends Component {
  constructor(props) {
    super(props);
    this.state = {                    // Refactor to envelope: { ... }
      isMine: false,
      envelope: null,
      iframeHeight: "500px",          // This way, you can use this.setState({ envelope })
      iframeWidth: "1000px",          // in a lot of places
      hot: {},
      tab: 'data',
      envKey: '',
      cssValue: '',
      jsValue: '',
      htmlValue: '',
      tableValue: [[]],
      name: '',
      description: '',
      settings: {},
      libraries: [],
      tags: [],
      i: 0,
      mounted: false,         // move this to this.mounted or something with this.refs:
      justUpdated: false      // https://stackoverflow.com/a/40969739/4691187
    }
  }

  componentDidMount = () => {
    this.setState({ mounted: true });
    if (typeof this.props.match.params.key !== 'undefined') {
      this._loadEnvelope();
    } else {
      this._updateIframe();
    };
    this._addListeners();
  }

  onCssChange = (cssValue) => {
    if (this.state.mounted) { this.setState({ cssValue: cssValue }); }
  }
  onHtmlChange = (htmlValue) => {
    if (this.state.mounted) { this.setState({ htmlValue: htmlValue }); }
  }
  onJsChange = (jsValue) => {
    if (this.state.mounted) { this.setState({ jsValue: jsValue }); }
  }

  onSettingsChange = (libraries) => {
    if(this.state.mounted) { this.setState({ libraries }); }
  }

  onOptionsChange = (type, value) => {
    var newState = {};
    newState[type] = value
    if(this.state.mounted) { this.setState( newState ); }
  }

  changeHot = (changes, source) => {
    if (changes !== null) this._updateIframe();
  }

  createPrivatelyWithPostOffice = () => {
    this._sendToPostOffice("createPrivately");
  }

  createWithPostOffice = () => {
    this._sendToPostOffice("create");
  }
  updateWithPostOffice = () => {
    this._sendToPostOffice("update", this.props.match.params.key);
  }
  updatePrivatelyWithPostOffice = () => {
    this._sendToPostOffice("updatePrivately", this.props.match.params.key);
  }
  forkWithPostOffice = () => {
    this._sendToPostOffice("fork", this.props.match.params.key);
  }
  deleteWithPostOffice = () => {
    this._sendToPostOffice("delete", this.props.match.params.key);
  }
  hostWithPostOffice = () => {
    this._sendToPostOffice("host", this.props.match.params.key);
  }

  _sendToPostOffice = (method, historyKey) => {
    var envelope = {
      name:         this.state.name,
      description:  this.state.description,
      libraries:    JSON.stringify(this.state.libraries),
      tags:         JSON.stringify(this.state.tags),
      isPublic:     method !== "createPrivately" && method !== "updatePrivately",

      htmlValue:    this.state.htmlValue,
      cssValue:     this.state.cssValue,
      jsValue:      this.state.jsValue,
      table:        typeof this.refs.hot !== "undefined" ?
                    this.refs.hot.hotInstance.getData() : null
    }
    if (method === "createPrivately") { method = "create" }
    if (method === "updatePrivately") { method = "update" }
    if (method === "host") { sendToPostOffice("host", historyKey, envelope); return; }

    sendToPostOffice(method, historyKey, envelope)
      .then(function(res) {
        if (res.status === "success") {

            this.setState({justUpdated: method}); // fade out
            this.timer = setTimeout(_ => {
              this.setState({justUpdated: false}); // fade back in
            }, 1000);

          if (method !== "update") {
            setTimeout(_ => {
              this.props.history.push('/run/' + res.key)
              this.setState({ isMine: true })
            }, 1000);
          }

        } else if (res.status === "unauthenticated") {
          console.warn ('UNAUTHENICATED. PLEASE LOG IN FIRST.')

          if (confirm("Please log in first!")) {
              var provider = new firebase.auth.GoogleAuthProvider();
              firebase.auth().signInWithRedirect(provider).then(function(result) {
                // this.forceUpdate();
              }).catch(function(error) {
                console.warn(error)
              });
          }
        } else {
          console.warn(res)
        }
      }.bind(this))
  }

  componentWillUnmount = () => {
    this._removeListeners();
  }

  render() {
    return (
      <div className="container" style={{ textAlign: "center" }}>
        {this.state.envelope ?
          <Iframe size="big" env={this.state.envelope}/> :
          <div id="iframe">Loading....</div> }
        <Tabs defaultActiveKey={this.state.tab}
              onSelect={this.handleSelect}
              id="controlled-tab-example"
              style={{ textAlign: "left" }}>
          <Tab eventKey={"settings"} title="Settings">
            <Settings
              settingsChange={this.onSettingsChange}
              libraries={this.state.libraries}/>
          </Tab>
          <Tab eventKey={"data"} title="Data">
            <HotTable
              root="hot"
              colHeaders={true}
              rowHeaders={true}
              width="1138"
              height="300"
              stretchH="all"
              minRows="122"
              minCols="36"
              afterChange={this.changeHot}
              contextMenu="true"
              ref="hot" />
          </Tab>
          <Tab eventKey={"js"} title="JS">
            <AceEditor
              mode="javascript"
              theme="monokai"
              width="100%"
              onChange={this.onJsChange}
              value={this.state.jsValue}
              name="jsEditor"
              editorProps={{$blockScrolling: true}}/>
          </Tab>
          <Tab eventKey={"html"} title="HTML">
            <AceEditor mode="html" theme="monokai" width="100%" onChange={this.onHtmlChange}
              value={this.state.htmlValue}
              name="htmlEditor" editorProps={{$blockScrolling: true}}/>
          </Tab>
          <Tab eventKey={"css"} title="CSS">
            <AceEditor mode="css" theme="monokai" width="100%" onChange={this.onCssChange}
              value={this.state.cssValue}
              name="cssEditor" editorProps={{$blockScrolling: true}}/>
          </Tab>
          <Tab eventKey={"options"} title="Options">
            <Options  authorId={this.state.authorId}
                      isNew={this.props.isNew}
                      onSave={this.handleSave}
                      onFork={this.handleFork}
                      onUpdate={this.handleUpdate}
                      name={this.state.name}
                      justUpdated={this.state.justUpdated}
                      description={this.state.description}
                      tags={this.state.tags}
                      optionsChange={this.onOptionsChange}
                      forkWithPostOffice={this.forkWithPostOffice}
                      updateWithPostOffice={this.updateWithPostOffice}
                      updatePrivatelyWithPostOffice={this.updatePrivatelyWithPostOffice}
                      deleteWithPostOffice={this.deleteWithPostOffice}
                      createWithPostOffice={this.createWithPostOffice}
                      createPrivatelyWithPostOffice={this.createPrivatelyWithPostOffice}
                      hostWithPostOffice={this.hostWithPostOffice}
                      user={this.props.user}/>
          </Tab>
        </Tabs>
      </div>
    )
  }

  _addListeners = () => {
    ['cssEditor', 'htmlEditor', 'jsEditor'].forEach(function(id) {
      document.getElementById(id).addEventListener('keydown', this._keyListener);
    }.bind(this));
  }

  _keyListener = (e) => {
    if(e.keyCode === 13 && e.metaKey) { this._updateIframe(); }
  }

  _loadEnvelope = () => {
    const key = this.props.match.params.key;
                                               // MOVE THIS TO FIREHELPER!  <===================//
    getEnvelopeDetails(key, this.refs.hot)                                                      //
      .then(function(env) {                                                                     //
        if (typeof env.table !== "undefined") {                                                 //
          const hotUpdate = env.table.map((row, i) => row.map((el, j) => [i, j, el] ))          //
            .reduce((a, b) => a.concat(b))                                                      //
            .filter(l => typeof l !== "undefined")                                              //
          this.refs.hot.hotInstance.setDataAtCell(hotUpdate)                                    //
        };
        this.setState({
          authorId: env.authorId,
          envelope: env,
          envKey: env.envKey,
          cssValue: env.cssValue || '',
          jsValue: env.jsValue || '',
          htmlValue: env.htmlValue || '',
          tableValue: env.table || [],
          name: env.name || '',
          description: env.description || '',
          settings: {},
          tags: JSON.parse(env.tags),
          libraries: env.libraries
        })
      }.bind(this))
  }

  _removeListeners = () => {
    this.setState({ mounted: false });
    ['cssEditor', 'htmlEditor', 'jsEditor'].forEach(function(id) {
      document.getElementById(id).removeEventListener('keydown', this._keyListener);
    }.bind(this))
  }

  _updateIframe = () => {
    const envelope = {
      htmlValue: this.state.htmlValue,
      cssValue: this.state.cssValue,
      jsValue: this.state.jsValue,
      table: this.refs.hot.hotInstance.getData(),
      libraries: this.state.libraries
    }
    this.setState({ envelope })
  }
}

export default withRouter(Envelope);



// WEBPACK FOOTER //
// ./src/Envelope.js